import classnames from 'classnames/bind'
import { STORYBLOK_TYPES } from '~/lib/storyblok-types'

import { PageViewAnalytics } from '~/components/PageViewAnalytics'
import PushGeneric from '~/components/Slices/PushGeneric'
import SideNavSubNavPageContent from '~/components/UI/SideNavTwoColumnsContent'

import getLegalPrivacySupportPageStaticPropsFunction, {
  getLegalPrivacySupportPageStaticPathsFunction,
} from '~/data/legal-privacy-support-page-data'
import { LegalPrivacySupportPageProps } from '~/data/legal-privacy-support-page-data/serializer'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export default function CustomerInformations({
  additionalPush,
  ...rest
}: LegalPrivacySupportPageProps) {
  return (
    <div className={cx(css.CustomerfInformations)}>
      <SideNavSubNavPageContent {...rest} index={0} />
      {additionalPush && (
        <PushGeneric className={cx(css.additionalPush)} {...additionalPush} />
      )}
      <PageViewAnalytics template="policy" />
    </div>
  )
}

export const getStaticProps = getLegalPrivacySupportPageStaticPropsFunction({
  type: STORYBLOK_TYPES.PRACTICAL_INFORMATIONS_PAGE,
})

export const getStaticPaths = getLegalPrivacySupportPageStaticPathsFunction({
  type: STORYBLOK_TYPES.PRACTICAL_INFORMATIONS_PAGE,
})
